var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(-338.42 -537.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_891",
    "data-name": "Line 891"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17799",
    "data-name": "Rectangle 17799",
    width: 24,
    height: 3,
    transform: "translate(338.42 537.52)",
    fill: "#474461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_892",
    "data-name": "Line 892"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17800",
    "data-name": "Rectangle 17800",
    width: 24,
    height: 3,
    transform: "translate(338.42 545.52)",
    fill: "#474461"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_893",
    "data-name": "Line 893"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17801",
    "data-name": "Rectangle 17801",
    width: 10,
    height: 3,
    transform: "translate(338.42 553.52)",
    fill: "#474461"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ee3bff14e75f79cdbf43946e7efe8ae8.svg";
export { ForwardRef as ReactComponent };